<template>
  <div :class="componentClasses">
    <slot />
    <slot
      v-if="showSidebar"
      name="other"
    />
    <div v-if="!optimizer" class="toggle">
      <p>Show speaker notes</p>
      <Toggle 
        :modelValue="showSidebar" 
        @update:modelValue="(value) => showSidebar = value"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { Toggle } from '@stakeui';

const props = defineProps({
  optimizer: {
    type: Boolean,
    default: false,
  },
});

const showSidebar = ref(false);

const componentClasses = computed(() => [
  'tw-flex tw-flex-col tw-bg-white tw-text-[#1F2229] tw-text-sm tw-gap-3 tw-p-5 tw-rounded-lg',
  props.optimizer ? `` : 'area-sidebar',
]);
</script>

<style scoped>
.area-sidebar {
  position: fixed;
  box-shadow: 0 0.5em 1em rgba(10, 10, 10, 0.2);
  right: 1rem;
  bottom: 1rem;
  z-index: 20;
  width: 18rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
}

.toggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
